import { EditOutlined } from '@ant-design/icons';
import { BasketballPlayer } from '@hefe/models';
import { ModalsSlice } from '@hefe/store';
import { Button, Space } from 'antd';
import { useAppDispatch } from '../../../../../store/store';
import EditPlayerForm from '../../../forms/edit-player/edit-player.form';

interface PlayersMoreActionsComponentProps {
  player: BasketballPlayer;
}

export default function PlayersMoreActionsComponent(
  props: PlayersMoreActionsComponentProps
) {
  const dispatch = useAppDispatch();

  const openPlayerSettings = () => {
    dispatch(
      ModalsSlice.modalsActions.openModal({
        title: `${props.player.firstname} ${props.player.lastname}`,
        formId: `edit-player-form-${props.player.id}`,
        component: <EditPlayerForm player={props.player} />,
      })
    );
  };

  return (
    <Space>
      <Button
        type="link"
        size="small"
        icon={<EditOutlined />}
        onClick={() => openPlayerSettings()}
      />
    </Space>
  );
}
